import { render, staticRenderFns } from "./research-questions.vue?vue&type=template&id=1c33b592&"
import script from "./research-questions.vue?vue&type=script&lang=js&"
export * from "./research-questions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c33b592')) {
      api.createRecord('1c33b592', component.options)
    } else {
      api.reload('1c33b592', component.options)
    }
    module.hot.accept("./research-questions.vue?vue&type=template&id=1c33b592&", function () {
      api.rerender('1c33b592', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/content-manage/research-questions/research-questions.vue"
export default component.exports